import labels from "./emailContentKitLabels.json";
import { getElakayLanguageCode } from "../dataElakay";

// The language store may be unavailable (tests mocking ../auth, very early
// render): English then.
const currentLanguage = () => { try { return getElakayLanguageCode(); } catch { return "en"; } };

// Labels of the email content editors in the current Elakay UI language;
// a missing key falls back to English (nested groups merged too).
export function kitText() {
  const current = labels[currentLanguage()] || {};
  return { ...labels.en, ...current, types: { ...labels.en.types, ...current.types }, categories: { ...labels.en.categories, ...current.categories }, settings: { ...labels.en.settings, ...current.settings } };
}
